import type { TreemapStatisticSelection } from '@/treemap/treemap.store';

/**
 * The statistics that can be shown on each node, ordered by their position in the toolbar. A statistic is shown only
 * once both its signal and its statistic are chosen and the signal is still in the worksheet.
 *
 * @param statistics - The statistics chosen in the toolbar, indexed by position
 * @param isInWorksheet - Whether the signal or scalar with the given id is still in the worksheet
 */
export function getValidStatistics(
  statistics: Array<TreemapStatisticSelection | undefined>,
  isInWorksheet: (id: string | number) => boolean,
): TreemapStatisticSelection[] {
  return statistics
    .filter((statistic): statistic is TreemapStatisticSelection => {
      const key = statistic?.key;
      const id = statistic?.id;
      return key !== undefined && key !== null && id !== undefined && id !== null && isInWorksheet(id);
    })
    .sort((first, second) => first.index - second.index);
}
